// A sync panel mock-up: no product surface mounts it and no record feeds it.
// Its status lines were invented ("Last version 1.2.1", "Synced 6 mins ago",
// "6 updates") and read as real activity wherever the component showed — they
// are gone (R2-M1 sweep). Real status needs a data contract first.
export const ActiveSyncInPublish = {
  flow: 'y',
  gap: 'A',
  margin: '- -Z2',
  Website: {
    extends: 'DomainItem',
    Icon: {
      name: 'globe'
    },
    Hgroup: {
      H: {
        text: '{{ publish.sync.website.title | polyglot }}'
      },
      P: null
    },
    Upgrade: null,
    align: 'start'
  },
  Figma: {
    extends: 'DomainItem',
    Icon: {
      name: 'figma'
    },
    Hgroup: {
      H: {
        text: 'Figma'
      },
      P: null
    },
    Upgrade: null,
    Sync: {
      extends: ['CanvasButton', 'Button'],
      padding: 'Y2 Z2',
      margin: '-Y1 -Z2 - -',
      fontSize: 'Z2',
      text: '{{ publish.action.sync | polyglot }}',
      icon: 'syncOvalFill',
      gap: 'Y1',
      Icon: {
        order: 2,
        color: 'blue'
      }
    },
    align: 'start'
  },
  Autosync: {
    extends: 'DomainItem',
    Icon: null,
    Hgroup: {
      H: {
        text: '{{ publish.sync.autosync | polyglot }}'
      },
      P: {
        text: '{{ publish.sync.autosyncHint | polyglot }}'
      }
    },
    Upgrade: null,
    Toggle: {
      margin: '- - - auto'
    },
    align: 'start'
  }
}
